function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesSprayFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 10.75a1 1 0 100-2 1 1 0 000 2zM24.45 9a1 1 0 100-2 1 1 0 000 2zM28 7.25a1 1 0 100-2 1 1 0 000 2zM17 9a1 1 0 100-2 1 1 0 000 2zM20.45 7.25a1 1 0 100-2 1 1 0 000 2zM23.85 5.55a1 1 0 100-2 1 1 0 000 2zM27.3 3.8a1 1 0 100-2 1 1 0 000 2zM20.45 10.75a1 1 0 100-2 1 1 0 000 2zM23.85 12.5a1 1 0 100-2 1 1 0 000 2zM27.3 14.25a1 1 0 100-2 1 1 0 000 2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13c-.298 0-.5.202-.5.5v14c0 .298.202.5.5.5h10c.298 0 .5-.202.5-.5v-14c0-.298-.202-.5-.5-.5h-10zm-2.5.5C3 12.098 4.098 11 5.5 11h10c1.402 0 2.5 1.098 2.5 2.5v14c0 1.402-1.098 2.5-2.5 2.5h-10A2.473 2.473 0 013 27.5v-14z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6c0-1.102.898-2 2-2h3c1.102 0 2 .898 2 2v7H7V6zm5 0H9v5h3V6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.269 17.186c.062-.248.42-.248.482 0 .186.768.483 1.697.904 2.118.434.434 1.387.731 2.155.917a.248.248 0 010 .483c-.818.211-1.833.533-2.155.868-.346.347-.668 1.412-.879 2.242-.062.248-.42.248-.483 0-.21-.817-.532-1.883-.891-2.242-.36-.36-1.4-.682-2.216-.88-.248-.062-.248-.421 0-.483.804-.198 1.845-.52 2.216-.892.359-.36.668-1.338.867-2.131zM12 9h1V7h-1c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesSprayFilled;